import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, IconButton } from "@mui/material";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";

import { FaUser } from "react-icons/fa";
import { MdImageNotSupported } from "react-icons/md";
import LikeCounter from "../LikeCounter/LikeCounter";
import PropTypes from "prop-types";
import styles from "./CreatorElement.module.css";

const CreatorElement = ({ image, picIcon, title, tag, nrLikes, isUserLiked, nrMoments, descriptor }) => {
  const [liked, setLiked] = useState(isUserLiked);
  const [likesCount, setLikesCount] = useState(nrLikes);
  const [imageError, setImageError] = useState(false);
  const [picIconError, setPicIconError] = useState(false);

  console.log('CreatorElement props:', {
    image,
    picIcon,
    title,
    tag,
    nrLikes,
    isUserLiked,
    nrMoments,
    descriptor,
  });
  
  const navigate = useNavigate();

  // const handleLikeClick = (e) => {
  //   e.stopPropagation();
  //   setLiked(!liked);
  //   setLikesCount(liked ? likesCount - 1 : likesCount + 1);
  // };

  const handleClick = () => {
    navigate(`/creator/${descriptor}`);
  };

  if (nrMoments === 0) return null;

  return (
    <Box className={styles.popularCreators} onClick={handleClick}>
      <Box className={styles.bg} />
      {!image || imageError ? (
        <Box className={styles.fallbackImageBox}>
          <MdImageNotSupported className={styles.fallbackIcon} />
          <Typography className={styles.fallbackText}>No Image</Typography>
        </Box>
      ) : (
        <img
          className={styles.artIcon}
          alt=""
          src={image}
          onError={() => setImageError(true)}
        />
      )}
      {!picIcon || picIconError ? (
        <Box className={styles.fallbackPicIcon}>
          <FaUser className={styles.picFallbackIcon} />
        </Box>
      ) : (
        <img
          className={styles.picIcon}
          alt=""
          src={picIcon}
          onError={() => setPicIconError(true)}
        />
      )}

      <Box className={styles.popularCreatorInfo}>
        <Box className={styles.popularCreatorNamePrice}>
            <Typography className={styles.title}>{title}</Typography>
            <Typography className={styles.tag}>{tag}</Typography>
        </Box>

        <Box className={styles.priceWrapper}>
          <Typography className={styles.nrMoments}>
            {nrMoments} {nrMoments === 1 ? "Moment" : "Moments"}
          </Typography>
        </Box>
      </Box>

      <LikeCounter 
        className={styles.likeBox}
        id={descriptor}
        initialLikes={likesCount}
        isLiked={liked}
        whiteBackground={true} 
        isCreator = {true}
      />
      {/* <Box className={styles.likeBox} onClick={handleLikeClick}>
        <IconButton className={styles.likeButton}>
          {liked ? <AiFillHeart className={styles.likedIcon} /> : <AiOutlineHeart className={styles.unlikedIcon} />}
        </IconButton>
        <Typography className={styles.likesCount}>{likesCount}</Typography>
      </Box> */}
    </Box>
  );
};

CreatorElement.propTypes = {
  image: PropTypes.string.isRequired,
  picIcon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
  nrLikes: PropTypes.number.isRequired,
  isUserLiked: PropTypes.bool.isRequired,
  nrMoments: PropTypes.number.isRequired,
  descriptor: PropTypes.string.isRequired,
};

export default CreatorElement;